import { createSelector } from '@ngrx/store';

import { APP_ROUTES } from '../app-global/router/app-routes';
import { RouterSelectors } from '../app-global/router/route.selectors';

import { selectVisiblePeopleTabs } from './people-tabs.selectors';

/**
 * Whether the user is already on the screen a tap on `tab` would open.
 *
 * `IonTabs.select` builds the tab root as `tabsPrefix/tab` and returns early when it equals the
 * active view's url, so every tab whose landing screen sits at the tab root is handled there and
 * this selector merely agrees. People is the exception: its landing screen depends on flags and
 * entitlements, so `/app/people` only ever redirects to a child and the comparison never matches.
 * The tab-tap handler stops the event when this is true.
 */
export const selectIsAtTabLanding = (tab: string) =>
  createSelector(RouterSelectors.selectMergedRoute, selectVisiblePeopleTabs, (route, visiblePeopleTabs) => {
    const landing = tab === APP_ROUTES.People ? visiblePeopleTabs[0]?.route : `/${APP_ROUTES.App}/${tab}`;
    if (!landing) return false;

    const path = (route?.url ?? '').split('?')[0].split('#')[0];
    return path === landing;
  });
